import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

// The store is divided in modules, which are loaded and linked dynamically.
export default new Vuex.Store({});
